<template>
  <!-- 企业发票 -->
  <div class="firm-body">
    <!-- 标题 企业发票 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">企业发票</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <div
          v-for="(item, index) in selectArr"
          :key="index"
          :class="select == item.id ? 'select-p' : ''"
          class="clickable-item"
          @click="handelSelect(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 1开具发票时显示 可开发票金额 历史已开具金额.. -->
      <div class="openable" v-if="select == 1">
        <div class="openable-left">
          <div class="GrossAmount">{{ ItCanBeOpened.invoicableAmount }}元</div>
          <div class="Tips">可开发票金额</div>
        </div>
        <div class="openable-left">
          <div class="details-p">
            历史已开具金额 <span>{{ ItCanBeOpened.invoicedAmount }}元</span>
          </div>
        </div>
      </div>
      <!-- 2 单选 -->
      <div class="single-choice" v-if="select == 2">
        <div
          class="single-choice-box"
          v-for="(item, index) in radioList1"
          :key="index"
        >
          <div
            :class="item.id == radio ? 'Select-box' : 'notSelect-box'"
            @click="handelSingleChoice(item)"
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <!-- 搜索 -->
      <el-form class="screen" :inline="true" v-if="select == 1" @submit.native.prevent>
      <el-form-item label="订单ID：">
      <div class="size-search">
      <el-input v-model="inputKJ" placeholder="请输入"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="消费类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="consumptionType" placeholder="请选择">
      <el-option label="全部" value=""></el-option>
      <el-option label="道具" value="0"></el-option>
      <el-option label="代理服务" value="1"></el-option>
      <el-option label="充值" value="2"></el-option>
      <el-option label="增值" value="3"></el-option>
      <el-option label="广告服务" value="4"></el-option>
      </el-select>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" class="user-Id">
      <el-date-picker
      v-model="value1KJ"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="value1KJ = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelResetKJ">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
      <!-- 搜索 -->
      <el-form class="screen" :inline="true" v-if="select == 2" @submit.native.prevent>
      <el-form-item label="订单ID：">
      <div class="size-search">
      <el-input v-model="input" placeholder="请输入"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="消费类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="consumptionType" placeholder="请选择">
      <el-option label="全部" value=""></el-option>
      <el-option label="道具" value="0"></el-option>
      <el-option label="代理服务" value="1"></el-option>
      <el-option label="充值" value="2"></el-option>
      <el-option label="增值" value="3"></el-option>
      <el-option label="广告服务" value="4"></el-option>
      </el-select>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" class="user-Id">
      <el-date-picker
      v-model="value1"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="value1 = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
      <!-- 批量开发票 -->
      <div class="BulkBilling" v-if="select == 1">
        <div>
          已选择{{ SelectedSet.length }}个订单，共代开金额：<span
            style="color: #fe574a"
            >{{ TotalAmount }}元</span
          >
        </div>
        <div class="ButtonArea">
          <div class="firm-clickable" @click="handelClick">批量开具发票</div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="tabulation">
        <tableInvoice
          v-if="select == '1'"
          :tableData="tableData"
          :ClearSel="ClearSel"
          :verifyData="verifyData"
          @handleSelectionChange="handleSelectionChange"
          @Refresh="Refresh"
        ></tableInvoice>
        <tableIntwe
          v-if="select == '2'"
          :tableData="tableData1"
          :verifyData="verifyData"
          @Refresh="Refresh"
          @handleDetail="handleDetail"
        ></tableIntwe>
        <ModuleThree
          :dataMsg="dataMsg"
          v-if="select == '3'"
          @Refresh="Refresh"
        ></ModuleThree>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box" v-if="select == '1' || select == '2'">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
    <!-- 代开发票弹窗 -->
    <ticketDialog
      :dialogVisible="dialogVisible"
      :num="ticketDialogNum"
      :acquiesce="acquiesce"
      :headList="dataMsg.headList"
      :mailList="dataMsg.mailList"
      :addressList="dataMsg.addressList"
      :isReissue="false"
      :isBatch="false"
      @handleCloseDele="handleCloseDele"
      @handleUnderstand="handleUnderstand"
    ></ticketDialog>
    <!-- 开票详情弹窗 -->
    <detailDialog
      :visible.sync="detailDialogVisible"
      :detailId="detailId"
      @handleClose="handleDetailClose"
    ></detailDialog>
  </div>
</template>

<script>
// 引入接口
import {
  queryInvoiceCount, // 我的发票查看发票统计（可开，已开金额）
  listCompanyInvoiceIssue, // 我的发票-代开发票列表
  listInvoiceAuditRecord, // 开票记录
  getInvoiceHeadAndMailInfo, //查看发票相关信息，发票抬头，邮寄地址，电子邮箱地址
  getInvoiceHeadSelect, // 获取所属发票抬头列表c
  getDefaultHeadAndMailInfo, // 代开发票获取默认抬头与地址邮箱
  batchIssueInvoice, // 批量开票
  getIdentityAudit, //获取法人信息认证
} from "../../../../assets/api/firm/firmCenter";
// 引入代开发票 表格组件
import tableInvoice from "./components/tableInvoice.vue";
// 引入开票记录 表格组件
import tableIntwe from "./components/tableIntwe.vue";
// 引入发票信息管理 组件
import ModuleThree from "./components/ModuleThree.vue";
// 引入代开发票弹窗 组件
import ticketDialog from "./components/ticketDialog.vue";
// 引入开票详情弹窗 组件
import detailDialog from "./components/detailDialog.vue";
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      tableData: [], // 表格数据
      tableData1: [], // 表格数据2
      dataMsg: {}, // 发票信息管理 列表数据
      selectArr: [
        { name: "开具发票", id: "1" },
        { name: "开票记录", id: "2" },
        { name: "发票信息管理", id: "3" },
      ], // 切换 代开发票  开票记录 发票信息管理
      select: "1", // 筛选
      radioList1: [
        { name: "全部", id: "" },
        { name: "成功", id: "1" },
        { name: "失败", id: "2" },
        { name: "正在审核", id: "0" },
        { name: "作废", id: "3" },
      ], // 开票记录筛选
      radio: "", // 单选
      value: "", // 开票主体
      value1: null, //时间
      input: "", //订单id
      input1: "", // 发票号

      value1KJ: null, // 表1时间
      inputKJ: "", // 表1订单id
      consumptionType: "", // 消费类型筛选 0道具 1代理服务 2充值 3增值
      ticketDialogNum: "", // 开票弹窗用的消费类型（与搜索筛选隔离）
      options: [], // 搜索下拉框数据
      dialogVisible: false, // 开票弹窗
      detailDialogVisible: false, // 开票详情弹窗
      detailId: null, // 开票详情id
      ItCanBeOpened: {}, // 可开金额，历史已开金额
      SelectedSet: [], // 表格1的选中数据 数组集合
      TotalAmount: "0", // 表格1的选中总金额
      acquiesce: {}, // 设置的默认
      ClearSel: 0, // 传给表格1 操作后清空已选
      verifyData: {}, // 法人信息 是否实名认证等
    };
  },
  components: {
    tableInvoice,
    ticketDialog,
    tableIntwe,
    ModuleThree,
    paging,
    detailDialog,
  },
  created() {
    // 查看发票统计(可开/已开金额)
    this.queryInvoiceCount();
    this.listCompanyInvoiceIssue();
    // 获取所属发票抬头列表 接口
    this.getInvoiceHeadSelect();
    // 获取法人信息认证 看是否实名认证 用于开具发票时判断
    this.getIdentityAudit();
  },
  methods: {
    // 获取法人信息认证
    getIdentityAudit() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
      };
      getIdentityAudit(data).then((res) => {
        if (res.code == 0) {
          this.verifyData = res.data;
        }
      });
    },
    // 操作完成刷新数据
    Refresh(resetPage = true) {
      if (resetPage) {
        this.pagingObj.currentPage = 1;
      }
      this.$nextTick(() => {
        if (this.select == 1 || this.select == "1") {
          this.listCompanyInvoiceIssue();
          this.queryInvoiceCount();
          this.ClearSel++;
          this.SelectedSet = [];
          this.TotalAmount = 0;
        } else if (this.select == 2 || this.select == "2") {
          this.listInvoiceAuditRecord();
        } else if (this.select == 3 || this.select == "3") {
          this.getInvoiceHeadAndMailInfo();
          this.getInvoiceHeadSelect();
        }
      });
    },

    // 搜索
    handelSearch() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      if (this.select == 1) {
        // 代开发票
        this.listCompanyInvoiceIssue();
      } else if (this.select == 2) {
        this.listInvoiceAuditRecord();
      }
    },
    // 重置
    handelResetKJ() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.value1KJ = null; //时间
      this.inputKJ = ""; //订单id
      this.consumptionType = ""; //消费类型
      this.listCompanyInvoiceIssue();
    },
    // 重置
    handelReset() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.value = ""; // 开票主体
      this.value1 = null; //时间
      this.input = ""; //订单id
      this.input1 = ""; // 发票号
      this.consumptionType = ""; //消费类型
      this.radio = ""; //发票状态
      this.listInvoiceAuditRecord();
    },

    // 查看发票统计（可开/已开金额）接口
    async queryInvoiceCount() {
      const res = await queryInvoiceCount();
      this.ItCanBeOpened = res.data;
    },

    // 我的发票开票列表 接口
    async listCompanyInvoiceIssue() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1KJ;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, //开票主体id
          orderNumber: this.inputKJ, // 订单id查询
          startTime: time, // 搜索/筛选传的 开始时间
          endTime: timeEnd, // 搜索/筛选传的 结束时间
          consumptionType: this.consumptionType, // 消费类型 0道具 1代理服务 2充值 3增值
        },
      };
      const res = await listCompanyInvoiceIssue(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      this.tableData = (res && res.data && res.data.list) || [];
      this.pagingObj.totalDevice = (res && res.data && res.data.total) || 0;
    },
    // 我的发票列表多选 数据及金额总和
    handleSelectionChange(num, val) {
      this.SelectedSet = val;
      this.TotalAmount = num;
    },

    // 开票记录
    async listInvoiceAuditRecord() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, // 企业id
          orderNum: this.input, // 订单ID
          startTime: time, // 申请-开始时间
          endTime: timeEnd, // 申请-结束时间
          status: this.radio, // 发票审批状态
          consumptionType: this.consumptionType, // 消费类型
        },
      };
      const res = await listInvoiceAuditRecord(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      this.tableData1 = (res && res.data && res.data.list) || [];
      this.pagingObj.totalDevice = (res && res.data && res.data.total) || 0;
    },

    // 发票信息管理
    async getInvoiceHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      const res = await getInvoiceHeadAndMailInfo(data);
      this.dataMsg = res.data;
    },

    // 获取所属发票抬头列表 接口
    async getInvoiceHeadSelect() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      const res = await getInvoiceHeadSelect(data);
      this.options = res.data;
    },

    //获取默认的地址/邮箱/抬头 接口
    async getDefaultHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      // 获取默认的地址/邮箱/抬头 接口
      const res1 = await getDefaultHeadAndMailInfo(data);
      this.acquiesce = res1.data;
    },
    //单选
    handelSingleChoice(item) {
      console.log(item,this.select);
      // 开票记录中 全部/成功/失败/正在审核筛选
      this.radio = item.id;
      this.listInvoiceAuditRecord();
    },
    // 点击批量开票
    handelClick() {
      if (!this.$checkAction()) return;
      if (this.SelectedSet.length > 0) {
        if (this.verifyData.auditStatus == 3) {
          // 弹窗用消费类型，不改搜索筛选
          this.ticketDialogNum = this.SelectedSet[0].consumptionType;
          this.getDefaultHeadAndMailInfo();
          this.getInvoiceHeadAndMailInfo();
          setTimeout(() => {
            this.dialogVisible = true;
          }, 100);
        } else {
          this.$tool.PromptBox("warning", "请先在企业安全管理中进行实名认证！");
        }
      } else {
        this.$tool.PromptBox("warning", "请选择一条数据！");
      }
    },
    //关闭弹窗
    handleCloseDele() {
      this.dialogVisible = false;
    },
    // 开票详情
    handleDetail(row) {
      this.detailId = row.id;
      this.detailDialogVisible = true;
    },
    // 关闭详情后刷新当前页列表，避免叠开其他弹框后列表状态滞后
    handleDetailClose() {
      this.detailDialogVisible = false;
      this.Refresh(false);
    },
    // 弹窗确认
    handleUnderstand(val, unlockConfirm) {
      const unlock =
        typeof unlockConfirm === "function" ? unlockConfirm : null;
      // 获取 选择消费记录的id集合
      var arr = [];
      var k = 0;
      for (var i in this.SelectedSet) {
        arr[k++] = this.SelectedSet[i].id;
      }

      // 调用批量开票接口
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
          recordIdList: arr, // 消费记录id
          type: Number(val.listArrSelect), //0电子1纸质
          headId: val.value, //抬头id
          attribute: Number(val.listArrSelect1), //0普通增值税发票1专用
          mailOrAddressId:
            val.listArrSelect == 0
              ? val.sendMail == 1
                ? val.value1
                : ""
              : val.value2, //邮箱/地址
          showFlag: val.showFlag, //是否展示 0否 1是
          sendMail: val.sendMail, //是否发送邮箱 0否 1是
        },
      };
      batchIssueInvoice(data)
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.dialogVisible = false;
            this.$nextTick(() => {
              this.Refresh();
            });
          }
        })
        .finally(() => {
          unlock && unlock();
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      if (this.select == 1) {
        // 调用代开发票列表接口s
        this.listCompanyInvoiceIssue();
      } else if (this.select == 2) {
        this.listInvoiceAuditRecord();
      } else if (this.select == 3) {
        this.getInvoiceHeadAndMailInfo();
      }
    },

    // 筛选
    handelSelect(num) {
      this.radio = "";
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.select = String(num);
      this.$nextTick(() => {
        if (this.select == "1") {
          this.listCompanyInvoiceIssue();
          this.queryInvoiceCount();
        } else if (this.select == "2") {
          this.listInvoiceAuditRecord();
        } else if (this.select == "3") {
          this.getInvoiceHeadAndMailInfo();
          this.getInvoiceHeadSelect();
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .firm-Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
}
// 切换
.Toggle {
  width: 100%;
  height: 30px;
  display: flex;
  color: #333333;
  text-align: center;
  font-weight: 400;
  div:nth-child(1) {
    margin-left: 20px;
  }
  div {
    margin-right: 40px;
    font-size: 16px;
    cursor: pointer;
  }
  .select-p {
    color: #409eff ;
    box-sizing: border-box;
    border-bottom: 2px solid #409eff ;
  }
}
// 1开具发票  可开金额
.openable {
  // width: 400px;
  min-width: 400px;
  margin-top: 30px;
  margin-right: auto;
  height: 70px;
  border: 1px solid #409eff ;
  border-radius: 5px;
  display: flex;
  .openable-left {
    min-width: 200px;
    height: 100%;
    // border: 1px solid gold;
    display: flex;
    flex-direction: column;
    div {
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-weight: 400;
      font-family: PingFangSC-Medium;
    }
    .GrossAmount {
      font-size: 18px;
      color: #fe574a;
    }
    .Tips {
      font-size: 18px;
      color: #409eff ;
    }
    .details-p {
      font-size: 14px;
      color: #666666;
      font-weight: 400;
      margin: auto;
      span {
        color: #333333;
      }
    }
  }
}
// 1 单选
.single-choice {
  width: 100%;
  height: 18px;
  line-height: 18px;
  margin-top: 30px;
  display: flex;
  .single-choice-box {
    display: flex;
      margin-right: 20px;
    .notSelect-box {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-image: url("../../../../assets/imgs/weigouxuan@3x.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
    .Select-box {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-image: url("../../../../assets/imgs/gouxuan@3x.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
    div {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      margin-left: 10px;
    }
  }
}
// 搜索
.screen {
  margin-top: 30px;
  position: relative;
}
// 批量开票
.BulkBilling {
  width: 100%;
  height: 35px;
  line-height: 35px;
  display: flex;
  margin-top: 28px;
  font-weight: 400;
  div {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
  }
  .ButtonArea {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    div {
      width: 120px;
      height: 35px;
      background: #409eff ;
      border-radius: 5px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }
  }
}
// 表格
.tabulation {
  min-width: 1080px;
  min-height: 400px;
  margin-top: 30px;
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    // margin-right: 45px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
